import { Skeleton } from "@/shared/ui";

interface Props {
  variant?: "full" | "cardsOnly";
}

export default function RequestsPageSkeleton({ variant = "full" }: Props) {
  if (variant === "cardsOnly") {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
        {Array.from({ length: 6 }).map(function renderCardSkeleton(_, i) {
          return (
            <div key={i} className="flex flex-col gap-4 radius-lg border surface-base-stroke surface-base-fill p-5">
              <Skeleton width={100} height={24} borderRadius={6} />
              <div className="flex items-center gap-2">
                <Skeleton width={40} height={40} borderRadius={8} />
                <Skeleton width={140} height={20} />
              </div>
              <div className="border-t surface-base-stroke" />
              <div className="flex items-center gap-1.5">
                <Skeleton width={16} height={16} />
                <Skeleton width={180} height={14} />
              </div>
              <div className="flex items-center justify-end">
                <Skeleton width={140} height={36} borderRadius={8} />
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  return (
    <div className="flex flex-col gap-4">
      <div className="p-6 radius-3xl surface-base-fill flex items-center gap-2">
        <Skeleton width={140} height={40} className="radius-sm" />
        <Skeleton width={140} height={40} className="radius-sm" />
      </div>

      <div className="radius-3xl surface-base-fill p-7">
        <div className="flex items-center gap-2 mb-7">
          <Skeleton width={192} height={32} className="radius-xs" />
          <Skeleton width={160} height={32} className="radius-xs" />
          <Skeleton width={160} height={32} className="radius-xs" />
          <Skeleton width={160} height={32} className="radius-xs" />
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-4">
          {Array.from({ length: 6 }).map(function renderCardSkeleton(_, i) {
            return (
              <div key={i} className="flex flex-col gap-4 radius-lg border surface-base-stroke surface-base-fill p-5">
                <Skeleton width={100} height={24} borderRadius={6} />
                <div className="flex items-center gap-2">
                  <Skeleton width={40} height={40} borderRadius={8} />
                  <Skeleton width={140} height={20} />
                </div>
                <div className="border-t surface-base-stroke" />
                <div className="flex items-center gap-1.5">
                  <Skeleton width={16} height={16} />
                  <Skeleton width={180} height={14} />
                </div>
                <div className="flex items-center justify-end">
                  <Skeleton width={140} height={36} borderRadius={8} />
                </div>
              </div>
            );
          })}
        </div>

        <div className="flex items-center justify-between mt-4">
          <Skeleton width={200} height={20} />
          <div className="flex items-center gap-2">
            <Skeleton width={32} height={32} />
            <Skeleton width={32} height={32} />
            <Skeleton width={32} height={32} />
          </div>
        </div>
      </div>
    </div>
  );
}
